module.exports = __webpack_public_path__ + "static/media/9DESA35.3439015f.jpg";